import React from 'react';

export interface PaginationInfoProps {
  startIndex: number;
  endIndex: number;
  totalItems: number;
  testId?: string;
}

export const PaginationInfo: React.FC<PaginationInfoProps> = React.memo(({
  startIndex,
  endIndex,
  totalItems,
  testId = 'pagination-info',
}) => {
  const ariaLabel = `Showing items ${startIndex} to ${endIndex} of ${totalItems}`;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      data-testid={testId}
      className="text-sm font-normal text-primary-500"
    >
      <span className="font-medium">
        {startIndex}-{endIndex}
      </span>
      <span> of </span>
      <span className="font-medium">{totalItems}</span>
    </div>
  );
});

PaginationInfo.displayName = 'PaginationInfo';
